<div class="modal-card">
  <div class="icon-circle">
    <img src="assets/icons/del-info-icon.svg" alt="info">
  </div>
  <h2 class="title">{{ title }}</h2>
  <p class="desc">
    {{ message }}
    <!-- <ng-container *ngIf="itemName">
      <br><br>
      <strong>{{ itemName }}</strong>
    </ng-container> -->
  </p>
  <div class="actions">
    <button class="btn btn-cancel" (click)="onCancel()">Cancel</button>
    <button class="btn btn-delete" (click)="onDelete()">Delete</button>
  </div>
</div>


